import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltip } from '@angular/material/tooltip'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { CallEntity } from '../call-entities.service'

/** Past this many entities the list is long enough that finding one by scrolling stops being practical. */
const SEARCH_THRESHOLD = 6

@Component({
  selector: 'app-minutes-document-switcher',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTooltip,
    TranslateDirective,
    TranslatePipe,
  ],
  templateUrl: './minutes-document-switcher.component.html',
  styleUrl: './minutes-document-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MinutesDocumentSwitcherComponent {
  @Input({ required: true })
  entities!: CallEntity[]

  @Input({ required: true })
  selectedCallEntityId!: number | null

  @Input()
  canManage = false

  @Output()
  selectionChange = new EventEmitter<number | null>()

  @Output()
  manage = new EventEmitter<void>()

  @ViewChild('searchInput')
  searchInput: ElementRef<HTMLInputElement> | null = null

  searchText = ''

  get isSearchable(): boolean {
    return this.entities.length > SEARCH_THRESHOLD
  }

  get selectedEntity(): CallEntity | null {
    return this.entities.find((entity) => entity.id === this.selectedCallEntityId) ?? null
  }

  get filteredEntities(): CallEntity[] {
    const needle = this.searchText.trim().toLocaleLowerCase()
    return needle === '' ? this.entities : this.entities.filter((entity) => entity.name.toLocaleLowerCase().includes(needle))
  }

  statusIcon(entity: CallEntity): string {
    switch (entity.minutesStatus) {
      case 'ONGOING':
        return 'hourglass_top'
      case 'FAILED':
        return 'error'
      default:
        return entity.hasMinutes ? 'article' : 'draft'
    }
  }

  onMenuOpened() {
    this.searchText = ''
    setTimeout(() => this.searchInput?.nativeElement.focus())
  }

  select(callEntityId: number | null) {
    this.selectionChange.emit(callEntityId)
  }
}
